import { CloseRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { black, greyEnabled, purple, purpleLight } from "../../../../theme/colors";

const MAX_COMMENT_LENGTH = 50;

export default function UpdateServiceStatus({
  open,
  onDialogClose,
  updateServiceStatus,
  title,
  subtitle,
  submitting = false,
}: {
  open: boolean;
  onDialogClose: () => void;
  updateServiceStatus: (remarks: string) => void;
  title: string;
  subtitle: string;
  submitting?: boolean;
}) {
  const [comments, setComments] = React.useState("");

  function submit() {
    updateServiceStatus(comments);
  }

  function handleClose() {
    if (submitting) return;
    onDialogClose();
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { borderRadius: 4, width: 440, maxWidth: "90vw" } }}
    >
      <DialogContent sx={{ p: 4 }}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="h6" fontWeight={700} color={black}>
            {title}
          </Typography>
          <IconButton size="small" onClick={handleClose} disabled={submitting}>
            <CloseRounded fontSize="small" />
          </IconButton>
        </Box>
        <Typography variant="body2" color={greyEnabled} fontWeight={600} mt={1} mb={2}>
          {subtitle}
        </Typography>
        <Box position="relative">
          <TextField
            multiline
            minRows={5}
            fullWidth
            value={comments}
            disabled={submitting}
            onChange={({ target: { value } }) => {
              setComments(value);
            }}
            inputProps={{
              maxLength: MAX_COMMENT_LENGTH,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
          <Typography
            variant="caption"
            color={greyEnabled}
            sx={{ position: "absolute", bottom: 8, left: 12 }}
          >{`${MAX_COMMENT_LENGTH - comments.length} characters left`}</Typography>
        </Box>
        <Box mt={3} display="flex" gap={1.5}>
          <Button
            fullWidth
            disabled={submitting}
            onClick={handleClose}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            disableElevation
            disabled={submitting || !comments}
            onClick={submit}
            startIcon={submitting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            Confirm
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
